import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { ChartModule } from 'angular-highcharts';
import { ToastrModule } from 'ngx-toastr';

import { AuthService } from '../components/auth/auth.service';
import { JwtInterceptor } from '../components/auth/jwt.interceptor';
import { AuthGuard } from '../components/auth/auth-guard.service';
import { LoginComponent } from './account/login/login.component';
import { AppRoutingModule } from './app-routing-module';
import { BodyBlockComponent } from './home/body-block.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { DashboardComponent } from './dashboard/dashboard.component';

import { ExcelService } from '../app/exceldownloader'
import { AgGridModule } from 'ag-grid-angular';
// import { LicenseManager } from 'ag-grid-enterprise';
// LicenseManager.setLicenseKey("OrderGenie_Synergy_Pvt_Ltd__MultiApp_1Devs_1Deployment_20_March_2020__MTU4NDY2MjQwMDAwMA==9f63ad49a34547b9b056cce9fe224840")
// import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { from } from 'rxjs';
// import { UsernameListComponent } from './usernamelist/usernamelist.component';
import { MasterModule } from '../app/master/master.module';

import { TransitionModule } from './transitions/transition.module';
import { UtilitiesModule } from './utilities/utilities.module';
import { ReportsModule } from './reports/reports.module';
import { ApprovalsModule } from './approvals/approvals.module';

//import { ApiService } from './service/api_service';







@NgModule({
    imports: [
        BrowserModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        AgGridModule.withComponents([]),
        // GooglePlaceModule,
        ToastrModule.forRoot({
            maxOpened: 1,
            autoDismiss: true
        }),
        ChartModule,
        MasterModule,
        TransitionModule,
        UtilitiesModule,
        ReportsModule,
        ApprovalsModule,
        AppRoutingModule,
        ChartModule,
    ],
    exports: [
        BrowserModule
    ],
    declarations: [
        AppComponent,
        LoginComponent,
        BodyBlockComponent,
        HeaderComponent,
        FooterComponent,
        DashboardComponent,
        // ChemistAddMasterComponent,
        // ProductListComponent,
        // EmployeeComponent,
        // ChartComponent,
        // MapTrackingComponent,
        // RouteMasterComponent,
        // RouteListComponent,
        // HqMasterComponent,
        // StockistMasterComponent,
        // EmptableComponent,
        // ExpenseComponent,
        // ExpenseDetailsComponent,
        // ExpenseDetailsEmpComponent,
        // TourProgramComponent,
        // TourProgramDataComponent,
        // TourProgrameditComponent,
        // TourEditDataComponent,
        // ChemistMasterMainComponent,
        // ChemistMasterDataComponent,
        // LiveAreaTrackingComponent,
        // LiveAreaTrackingDataComponent,
        // DcrComponent,
        // AreaBeetMasterComponent,
        // UsernameListComponent,
        // ImeiResetComponent,
        // ExpenseMasterComponent,
        // POReportComponent
    ],
    bootstrap: [AppComponent],
    providers: [
        ExcelService,
        AuthService,
        AuthGuard,
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true }
    ]
})
export class AppModule {

}
